"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moneyV2Range = exports.multiplyMoneyV2 = exports.subtractMoneyV2 = exports.addMoneyV2 = exports.sumMoneyV2 = exports.moneyV2Equals = exports.greaterThan = exports.lessThan = exports.moneyRangeToString = exports.moneyV2ToString = exports.EmptyMoneyV2 = void 0;
exports.EmptyMoneyV2 = {
    amount: "0.00",
    // @ts-ignore
    currencyCode: "USD",
};
function ensureSameCurrency(...moneys) {
    const flatMoneys = moneys.flat(1);
    const same = flatMoneys.every(money => money.currencyCode === flatMoneys[0].currencyCode);
    if (!same) {
        throw new Error("Money has different currency type.");
    }
}
function moneyV2ToString(money, shorten = true) {
    const amount = parseFloat(money.amount);
    const hasCents = amount % 1 !== 0;
    const amountStr = shorten && !hasCents ? amount.toFixed(0) : amount.toFixed(2);
    if (money.currencyCode === "USD") {
        return "$" + amountStr;
    }
    else {
        return `${amountStr}{moneyV2.currencyCode}`;
    }
}
exports.moneyV2ToString = moneyV2ToString;
function moneyRangeToString(min, max) {
    ensureSameCurrency(min, max);
    if (moneyV2Equals(min, max)) {
        return moneyV2ToString(min);
    }
    else {
        return `${moneyV2ToString(min)} - ${moneyV2ToString(max)}`;
    }
}
exports.moneyRangeToString = moneyRangeToString;
function lessThan(a, b) {
    ensureSameCurrency(a, b);
    return parseFloat(a.amount) < parseFloat(b.amount);
}
exports.lessThan = lessThan;
function greaterThan(a, b) {
    ensureSameCurrency(a, b);
    return parseFloat(a.amount) > parseFloat(b.amount);
}
exports.greaterThan = greaterThan;
function moneyV2Equals(a, b) {
    if (!a || !b) {
        return !a && !b;
    }
    return a.amount === b.amount && a.currencyCode === b.currencyCode;
}
exports.moneyV2Equals = moneyV2Equals;
function sumMoneyV2(moneys) {
    ensureSameCurrency(moneys);
    return moneys.reduce((sum, money) => addMoneyV2(sum, money), exports.EmptyMoneyV2);
}
exports.sumMoneyV2 = sumMoneyV2;
function addMoneyV2(a, b = exports.EmptyMoneyV2) {
    ensureSameCurrency(a, b);
    const totalAmount = parseFloat(a.amount) + parseFloat(b.amount);
    return {
        currencyCode: a.currencyCode,
        amount: totalAmount.toFixed(precision(a)),
    };
}
exports.addMoneyV2 = addMoneyV2;
function subtractMoneyV2(a, b = exports.EmptyMoneyV2) {
    ensureSameCurrency(a, b);
    return addMoneyV2(a, multiplyMoneyV2(b, -1));
}
exports.subtractMoneyV2 = subtractMoneyV2;
function multiplyMoneyV2(money = exports.EmptyMoneyV2, multiplyBy = 1) {
    if (multiplyBy === 1) {
        return money;
    }
    const totalAmount = parseFloat(money.amount) * multiplyBy;
    return {
        currencyCode: money.currencyCode,
        amount: totalAmount.toFixed(precision(money)),
    };
}
exports.multiplyMoneyV2 = multiplyMoneyV2;
function moneyV2Range(moneys) {
    if (moneys.length === 0) {
        throw new Error("Cannot create price range from a set of 0 prices.");
    }
    ensureSameCurrency(moneys);
    const range = {
        minVariantPrice: moneys[0],
        maxVariantPrice: moneys[0],
    };
    for (let money of moneys) {
        if (lessThan(money, range.minVariantPrice)) {
            range.minVariantPrice = money;
        }
        if (greaterThan(money, range.maxVariantPrice)) {
            range.maxVariantPrice = money;
        }
    }
    return range;
}
exports.moneyV2Range = moneyV2Range;
function precision(money) {
    return (money.amount.toString().split(".")[1] || "").length;
}
//# sourceMappingURL=data:application/json;base64,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